import React from 'react'
import { rem } from 'polished'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import CategoryTile from 'components/Luxkit/CategoryTile'
import { fireInteractionEvent } from 'api/googleTagManager'
import { cruiseDestinationTileClick } from 'analytics/eventDefinitions'
import qs from 'qs'

const locations = [
  {
    name: 'Cruises from Sydney',
    image: { id: 'v4kwli3fa6d30n2w1rk9' },
    filter: qs.stringify({
      portId: 'le_678c61ac5b4f91ca86e112fc50e63766',
      portName: 'Sydney',
    }),
  },
  {
    name: 'Cruises from Brisbane',
    image: { id: 'e3shvrl7vnuw84mb3fbj' },
    filter: qs.stringify({
      portId: 'le_b96d145f6c31e35755f4a6841574ba37',
      portName: 'Brisbane',
    }),
  },
  {
    name: 'Cruises from Melbourne',
    image: { id: '3wgitcdr0mdfwtfa02ve' },
    filter: qs.stringify({
      portId: 'le_15fa44474c92da27cf2125373356db4c',
      portName: 'Melbourne',
    }),
  },
  {
    name: 'Mediterranean Cruises',
    image: { id: 'vwzs7x9qceuln1uhnii' },
    filter: qs.stringify({
      destinationId: 'le_675c2bf8873ef7dc8e8b6ba66366a158',
      destinationName: 'Civitavecchia',
    }),
  },
  {
    name: 'New Zealand Cruises',
    image: { id: '4fb6ibesnkam6np2rd3c' },
    filter: qs.stringify({
      destinationId: 'le_9fc3d7152ba9336a670e36d0ed79bc43',
      destinationName: 'New Zealand',
    }),
  },
  {
    name: 'South Pacific Cruises',
    image: { id: 'k9ms6hbvzrnln6o4oluc' },
    filter: qs.stringify({
      destinationId: 'le_a8697c7e6e7988b29a9de094b8d554cc',
      destinationName: 'South Pacific',
      cruiseLines: ['RCC', 'NCL', 'CEL'],
    }, { indices: false }),
  },
]

function CruisePageDestinationTiles() {
  return <CardCarousel pageSize={6} width={rem(180)}>
    {locations.map((location) => <CategoryTile
      href={`/search/cruises?${location.filter}`}
      key={location.image.id}
      image={location.image}
      heading={location.name}
      subHeading=""
      align="top"
      callToAction="View offers"
      onClick={() => fireInteractionEvent(cruiseDestinationTileClick(location.name))}
    />)}
  </CardCarousel>
}

export default CruisePageDestinationTiles
